module.exports = __webpack_public_path__ + "img/Newbie_Bow_03_Classic.ad93702a.png";